interface Heading {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

const SectionHeading = ({ title, subtitle }: Heading) => {
  return (
    <div className="relative inline-block mb-2">
      <div>{title}</div>

      {subtitle && (
        <div className="text-xl text-gray-400 mt-2">
          {subtitle}
        </div>
      )}

      <span className="absolute mt-1 left-0 -bottom-1 w-[30%] h-[2px] bg-yellow-700 rounded-full"></span>
    </div>
  );
};
export default SectionHeading;